import { FilterSearchPayload } from "@/app/home/components/table/DataTable";
import { FactoryBillingRepo } from "@/core/repos/tables/factory-billing.repo";
import { WaterIndexRepo } from "@/core/repos/tables/water-index.repo";
import { WaterInvoiceRepo } from "@/core/repos/tables/water-invoice.repo";
import container from "@/lib/di/container";
import { Button, message, Modal, Progress } from "antd";
import { useState, useEffect, Dispatch, SetStateAction } from "react";
const waterIndexRepo = container.get(WaterIndexRepo);
interface InitWaterIndexModalProps {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  data: {
    total: number;
    filterMap: Map<string, FilterSearchPayload>;
  };
}
export const InitWaterIndexModal: React.FC<InitWaterIndexModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  data,
}) => {
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [loading, setLoading] = useState<boolean>(false);

  async function initAll() {
    setLoading(true);
    const month = data.filterMap.get("month")?.value as string;
    const year = data.filterMap.get("year")?.value as string;
    if (month && year) {
      await waterIndexRepo.initAll(month, year);
      message.success({
        content: `Bạn đã khởi tạo thành công Chỉ số nước tháng ${month}/${year}`,
      });
    } else {
      message.error({
        content: `Bạn cần phải chọn tháng và năm!`,
      });
    }

    setLoading(false);
  }
  const handleSave = async () => {
    setLoading(true);
    await initAll();
    setIsModalOpen(false);
    setLoading(false);
  };
  return (
    <Modal
      open={isModalOpen}
      onCancel={handleCancel}
      width={600}
      style={{
        top: 20,
      }}
      styles={{
        mask: {
          backdropFilter: "blur(2px)",
          backgroundColor: "var(--primary-mask)",
        },
      }}
      footer={[
        <div key={1} className="w-full flex flex-row justify-end px-1.5">
          <Button
            key="submit"
            type="primary"
            loading={loading}
            style={{
              background: "var(--primary-color)",
              paddingRight: 48,
              paddingLeft: 48,
              fontSize: 18,
              fontWeight: 600,
              paddingTop: 18,
              paddingBottom: 18,
            }}
            onClick={handleSave}
          >
            Xác nhận
          </Button>
        </div>,
      ]}
    >
      <div className="flex flex-row w-full items-start justify-start select-none">
        <p className="ml-6 text-2xl font-bold text-primary">
          Khởi tạo chỉ số nước
        </p>
      </div>
      <div className="flex flex-col items-center">
        <div className="py-4 px-4 w-full">
          <div>
            Xác nhận khởi tạo chỉ số nước tháng{" "}
            <b>{`${data.filterMap.get("month")?.value}-${
              data.filterMap.get("year")?.value
            }`}</b>{" "}
          </div>
        </div>
      </div>
    </Modal>
  );
};
